export default __webpack_public_path__ + "static/silverXsCover-94960db6edd3bb2cd3abe5c6950908cc.png";